import BaseValidator from 'ember-cp-validations/validators/base';
const AllPointersHaveSelectors = BaseValidator.extend({
  validate(pointerSteps) {
    let isValid = pointerSteps.every(step => step.validations.isValid);
    return isValid || 'Your tour has one or more pointer steps that are missing a selector.';
  }
});
AllPointersHaveSelectors.reopenClass({
  getDependentsFor() {
    return ['model.pointerSteps.@each.hasSelector'];
  }
});
export default AllPointersHaveSelectors;